
import { computed, defineComponent, SetupContext, PropType, toRefs, watch, ref } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "FridgeDetailsConfirmCoolingAssistSettingDialog",
  props: {
    /** ダイアログのアクティブ状態 (true: 活性、false: 非活性) */
    isShowDialog: {
      type: Boolean,
      default: false
    },
    /** マイリスト名 */
    listName: {
      type: String,
      default: null
    },
    /** 種類 */
    modeName: {
      type: String,
      required: true
    },
    /** 分 */
    minutes: {
      type: Number,
      required: true
    },
    /** 分 */
    seconds: {
      type: Number,
      default: 0
    },
    isValidSeconds: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const displayTitle = "設定確認";
    const minutesxText = "分";
    const secondsText = "秒"
    const settingText = "に設定します。";
    const noteText = "取り出しが遅れると凍結します\nのでご注意ください。";
    const cancelText = "キャンセル";
    const sendText = "送信";

    const timeText = computed(() => {
      if (props.isValidSeconds) {
        let secondsString = `${props.seconds}`;
        if (props.seconds == 0) {
          secondsString = "00";
        }
        return `${props.minutes}分${secondsString}秒`;
      }
      return `${props.minutes}分`;
    });

    const isValidFrozenMessage = computed(() => {
      if (props.modeName == "急凍") {
        return false;
      }
      return true;
    });

    const cancelClicked = () => {
      context.emit("click-cancel");
    };

    const sendClicked = () => {
      context.emit("click-send");
    };

    return {
      displayTitle,
      timeText,
      settingText,
      isValidFrozenMessage,
      noteText,
      cancelText,
      sendText,
      cancelClicked,
      sendClicked
    };
  }
});
